/** @format */
import { commonSharedModule } from './shared.module';

(function () {
    'use strict';

    rangeTypeFactory.$inject = ['defineEnum'];
    angular.module(commonSharedModule).factory('RangeType', rangeTypeFactory);

    function rangeTypeFactory(defineEnum) {
        return defineEnum(['ONE', 'EXACTLY', 'MAX', 'BETWEEN', 'MIN']);
    }
})();
